// frontend/src/components/PrivateRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TokenStorage } from '../utils/api';

export default function PrivateRoute({ children }) {
  const token = TokenStorage.getToken();
  const location = useLocation();

  // If no token, redirect to login with `redirect` back to intended path (pathname + search)
  if (!token) {
    const intended = `${location.pathname}${location.search || ''}`;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(intended)}`}
        replace
      />
    );
  }

  // Otherwise render the protected component
  return children;
}